import {eTipoPermissao} from '@/enums/ePermissoes';
import Index from '@/views/patrimonio/pattipobem/Index.vue';
import InclusaoEdicao from '@/views/patrimonio/pattipobem/InclusaoEdicao.vue';
export default [
 {
  description: 'Tipo de Bem',
  path: '/patrimonio/pattipobem/:id?',
  parent: 'patgrupobem',
  name: 'pattipobem',
  component: Index,
  meta: {
    permissions: [eTipoPermissao.LISTADEINVENTARIONOVO_MENU_1200300199],
  },
  goesToMenu: true,
},
{
  description: 'Cadastro de Tipo de Bem',
  path: '/patrimonio/pattipobem/cadastro/:patGrupoId/:id?',
  parent: 'pattipobem',
  name: 'pattipobem_create',
  component: InclusaoEdicao,
  meta: {
    permissions: [eTipoPermissao.LISTADEINVENTARIONOVO_MENU_1200300199],
  },
  goesToMenu: true,
}]
